var select = tokens => ({
  box: {
    width: '245px',
    maxWidth: '100%',
    margin: " ".concat(tokens.spacingX['xs'], " ").concat(tokens.spacingY['sm'])
  },
  trigger: {
    height: '64px',
    borderRadius: tokens.radius['4xl'],
    padding: "0 ".concat(tokens.spacingX['5xl']),
    color: tokens.colors.neutral[80],
    backgroundColor: tokens.colors.neutral[10],
    boxShadow: tokens.shadow.sm,
    transition: tokens.motion.sm,
    disabled: {
      color: tokens.colors.neutral[40]
    },
    focus: {
      backgroundColor: tokens.colors.neutral[0],
      boxShadow: tokens.shadow.md
    }
  },
  triggerContent: {
    width: '100%'
  },
  content: {
    minWidth: '245px',
    width: '100%',
    top: '64px',
    left: '0',
    boxShadow: tokens.shadow.xs,
    borderRadius: tokens.radius['4xl']
  },
  hint: {
    margin: "".concat(tokens.spacingTop.md, "} 0 0 0")
  },
  item: {
    backgroundColor: tokens.colors.neutral[0],
    color: tokens.colors.neutral[80],
    padding: "".concat(tokens.spacingY['5xl'], " ").concat(tokens.spacingY['4xl']),
    focus: {
      backgroundColor: tokens.colors.neutral[10]
    }
  }
});

export default select;
//# sourceMappingURL=select.js.map